import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { SeoMetaService } from 'src/app/modules/aa-core/services/seo-meta-service';
import { ActivatedRoute } from '@angular/router';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { BaseRouterComponent } from 'src/app/modules/aa-core/components/base-router/base-router.component';
import { RoutePlannerInputService } from '../../services/route-planner-input/route-planner-input.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { EventsService } from 'src/app/core/services/events.service';
import { LocationManagerService } from '../../services/location-manager/location-manager.service';
import { RoutePlannerViaService } from '../../services/route-via/route-via.service';
import { AppSettings } from 'src/app/core/shared';
import { RouteValidationMessage, GoogleMapOptionsEvents, RoutePlanerEventTracker } from 'src/app/core/events/events';
import { AppError } from 'src/app/core/models/constants';
import { RoutePlannerService } from '../../services/route-planner/route-planner.service';
import { IMobileNavigationEventModel } from 'src/app/core/models/models';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';

@Component({
  selector: 'app-route-planner',
  templateUrl: './route-planner.component.html',
  styleUrls: ['./route-planner.component.scss'],
  standalone: false
})
export class RoutePlannerComponent extends BaseRouterComponent implements OnInit, OnDestroy {
  private trafficAlertTimer: any;
  public showMenuOptionUI = false;
  private lastEmitTime: Date = new Date();

  constructor(
    public seoService: SeoMetaService,
    public appService: AppService,
    public routePlannerService: RoutePlannerService,
    public activatedRoute: ActivatedRoute,
    public cdr: ChangeDetectorRef,
    public routeInputService: RoutePlannerInputService,
    public locationManager: LocationManagerService,
    public routePlannerViaService: RoutePlannerViaService,
    public eventServices: EventsService,
    public appUtilityService: AppUtilityService
  ) {
    super(activatedRoute, null, appUtilityService, seoService);

    this.appService.routerType = this.routerType = AARouterURL.ROUTE_PLANNER;
  }

  ngOnInit() {
    this.loadParams();
    this.applySiteTag();
    this.applySEO();
    this.showMenuOptionUI = true;

    // initialize the scroll position
    this.mapMobileMenu.scrollYPosition = 0;
  }

  public onWindowResize(): void {
    clearTimeout(this.trafficAlertTimer);
    this.trafficAlertTimer = setTimeout(() => {
      const googleMapStoreModel = this.routePlannerService.googleMapStoreModel;
      googleMapStoreModel.mapInstance.invalidateCluster();
    }, 500);
  }

  public mobileMenuTabHandler(event: IMobileNavigationEventModel) {
    super.mobileMenuTabHandler(event);

    /**
     * MOBILE VIEW
     * Handle Window scroll Y position
     */
    // Set the scrollY position of window
    if (event.ActivePage === AARouterURL.ROUTE_PLANNER && event.ActiveTab === AARouterURL.ROUTE_PLANNER) {
      setTimeout(() => {
        window.scrollTo(0, this.mapMobileMenu.scrollYPosition);
        this.mapMobileMenu.scrollYPosition = 0;
      }, 50);
    } else {
      // store the scrollY position
      this.mapMobileMenu.scrollYPosition = window.scrollY;
    }
  }

  ngOnDestroy() {
    this.unSubscribeObservableEvents();
    this.eventServices.dispatch(GoogleMapOptionsEvents.CLEAR_CLRSTER_DATA);
  }

  public initMap(params) {
    this.routeInputService.initMap(params);
  }

  onShowRoute(evt?: UIEvent) {

    const lastTriggeredInterval = (new Date().getTime() - this.lastEmitTime.getTime()) / (AppSettings.INTERVAL_IN_SECONDS * 1000);
    if (lastTriggeredInterval < AppSettings.INTERVAL_IN_SECONDS) {
      console.log('request ignored as interval was ', lastTriggeredInterval);
      return;
    }

    this.reset();
    this.locationManager.fromLocation.errorMessage = '';
    this.locationManager.toLocation.errorMessage = '';
    // reset the max via points error message
    this.eventServices.dispatch(RouteValidationMessage.MAX_VIA_MESSAGE, '');

    if (this.locationManager.fromLocation.Name === '' || this.locationManager.toLocation.Name === '') {
      this.eventServices.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, AppError.ROUTE_LOCATION_MISSING);
      return;
    }

    if (this.locationManager.validateFromToLocation() && this.routePlannerViaService.validateViaRoute()) {
      this.routePlannerService.updateGoogleMap();
      if (evt instanceof UIEvent) {
      this.appService.trackingAndSeoService.link({
        event_category: 'Route Planner',
        event_name: 'Plan route - button clicked'
      });
    }
      this.eventServices.dispatch(RoutePlanerEventTracker.TAG_VIEW);
    } else {
      const viaCheck = this.routePlannerViaService.validateViaRoute();
      if (viaCheck === false) {
        this.eventServices.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.ROUTE_LOCATION_MISSING);
      } else {
        this.eventServices.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, AppError.ROUTE_LOCATION_NOT_FOUND);
        this.eventServices.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.ROUTE_LOCATION_NOT_FOUND);
      }
    }
    this.lastEmitTime = new Date();
  }

  reset(): void {
    this.locationManager.generalErrorMessage = '';
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 10);
  }
}
